// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store'

import Service from '@/common/plugins/service'
import Modal from '@/common/plugins/Modal/modal'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import VueParticles from 'vue-particles'

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer)

Vue.use(VueParticles)

Vue.use(Vuetify, {
  theme: {
    primary: '#402D34',
    secondary: '#534F7F',
    accent: '#613F37',
    error: '#b71c1c'
  }
})

Vue.use(Service, {
  apiUrl: process.env.API_URL,
  authToken: process.env.AUTH_TOKEN,
  docUrl: process.env.DOC_URL
})

Vue.use(Modal)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js